import {GET_GAMES, GET_GAME_DETAIL, GET_SIMILAR_GAMES, GET_SEARCHED_GAMES, GET_FAVOURITE_GAMES, SET_FAVOURITE_GAME,CATEGORY_GAMES} from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    games: [],
    gameDetail: [],
    similarGames: [],
    favoriteGames:[],
    searchedGames: [],
    categoryGames:[]
};

export const GamesReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_GAMES:
            return {
                ...state,
                games: action.data.data
            };
        case GET_GAME_DETAIL:

            return {
                ...state,
                gameDetail: action.data,
    };
        case GET_SIMILAR_GAMES:
            return {
                ...state,
                similarGames: action.data,
            };
        case GET_SEARCHED_GAMES:
            return {
                ...state,
                searchedGames: action.data.data
            };
        case GET_FAVOURITE_GAMES:
            return {
                ...state,
                favoriteGames: action.data.data
            };
        case CATEGORY_GAMES:
            return{
                ...state,
                categoryGames:action.data.data
            }

        case SET_FAVOURITE_GAME:
            console_log(action.data);
            return {
                ...state,
                games: action.data.games,
                favoriteGames: action.data.favoriteGames
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/GamesReducer.js